<component v-bind:is="getContainerType" v-bind:class="getClassName">
    <table>
        <tr :class="getClassName + 'Header'">
            <th v-for="(colHeader, key) in getColHeaders" v-bind:key="key">{{ $t(colHeader) }}</th>
        </tr>
        <tr v-for="(qtyRow,key) in getQuantities" v-bind:key="key"
            v-on:click="getSetQuantityFunction(qtyRow.quantity, qtyRow.code)" v-bind:class="activeClass(qtyRow.active)">
            <td :class="getClassName + 'Quantity'">{{qtyRow.quantity}}</td>
            <td :class="getClassName + 'Price'" v-if="canDisplayNetPrice()">{{qtyRow.formatted_base_price ? qtyRow.formatted_base_price : $n(qtyRow.base_price, 'currency')}}</td>
            <td :class="getClassName + 'Price'" v-if="canDisplayGrossPrice()">{{qtyRow.formatted_gross_price ? qtyRow.formatted_gross_price : $n(qtyRow.gross_price, 'currency')}}</td>
        </tr>
    </table>
    <div :class="getClassName + 'InfoText'">
        {{ $t('*VAT and delivery costs calculated at checkout')}}
    </div>
</component>